import styled from 'styled-components';

const ErrorMessage = styled.span`
  display: inline-block;
  margin-top: 5px;
  min-height: 15px;

  line-height: 15px;
  font-size: 13px;
  color: ${({ theme }) => theme.palette.error};
`;

export default ErrorMessage;
